import { IOrgMember } from '@/types/IOrgMember';
import { Grid, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import Member from './components/member/member.view';

interface IPartnersTableProps {
	members: Array<IOrgMember>;
	onRemoveMember: (memberId: string) => Promise<void>;
}

export default function MembersTable(props: IPartnersTableProps) {
	return (
		<Grid gap={2}>
			<Text px={2} fontWeight={600}>
				{t('Members')}
			</Text>
			{props.members.map((member) => (
				<Member key={member.id} member={member} onRemoveMember={props.onRemoveMember} />
			))}
		</Grid>
	);
}
